module.exports = __webpack_public_path__ + "img/1.04c68195.png";